import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@uzurv/afp/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { UzurvDirectivesModule } from '@uzurv/core';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';

@NgModule({
  imports: [CommonModule, ButtonModule, MatDialogModule, MatIconModule, UzurvDirectivesModule],
  exports: [ConfirmationDialogComponent],
  declarations: [ConfirmationDialogComponent]
})
export class ConfirmationDialogModule {}
